import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { apiBaseUrl } from '../APIs/endpoints';
import axios from 'axios';
import TranspozeLogo from '../commonComp/TranspozeLogo.svg';

const LoginPage = () => {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    setErrorMessage('');

    const user = {
      username: username.toLowerCase(),
      password: password
    };

    try {
      const { data } = await axios.post(
        `${apiBaseUrl}/token/`,
        user,
        { headers: { 'Content-Type': 'application/json' } },
        { withCredentials: true }
      );

      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);
      localStorage.setItem('user', username.toLowerCase());
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.access}`;

      const schoolResponse = await axios.get(`${apiBaseUrl}/api/get_school_name/`, {
        headers: { 'Authorization': `Bearer ${data.access}` }
      });
      localStorage.setItem('school_name', schoolResponse.data.school);

      const subjectsResponse = await fetchSubjects(schoolResponse.data.school);
      if (subjectsResponse) {
        localStorage.setItem('subjects', JSON.stringify(subjectsResponse));
      }

      window.location.href = '/';

    } catch (error) {
      setErrorMessage(error.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubjects = async (schoolName) => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/subjects?school=${encodeURIComponent(schoolName)}`);
      const gradesWithSubjects = response.data.grades;
      const subjectsByGrade = Object.entries(gradesWithSubjects).map(([grade, subjects]) => ({
        grade,
        subjects,
      }));
      return subjectsByGrade;
    } catch (error) {
      console.error('Failed to fetch subjects:', error);
      return null;
    }
  };

  const handleUsernameChange = (e) => {
    setUserName(e.target.value);
  };

  return (
    <div className="flex w-full min-h-screen">
      {/* Left Section - takes 50% width on large screens */}
      <div className="hidden lg:flex relative lg:w-1/2 h-screen bg-gradient-to-b from-[#0575E6] via-[#02298A] to-[#021B79] text-white p-10 flex-col justify-between overflow-hidden">
        {/* Background circles */}
        <svg className="absolute -top-[317px] -left-[378px] opacity-10 z-0" width="557" height="557" fill="none">
          <circle cx="278.5" cy="278.5" r="278" stroke="white" strokeWidth="1" />
        </svg>
        <svg className="absolute -top-[291px] -left-[297px] opacity-10 z-0" width="557" height="557" fill="none">
          <circle cx="278.5" cy="278.5" r="278" stroke="white" strokeWidth="1" />
        </svg>

        {/* Logo + Title + Subtitle */}
        <div className="z-10 flex flex-col">
          <div className="flex items-start">
            <img
              src={TranspozeLogo}
              alt="Transpoze Logo"
              className="mr-5 mt-1 filter invert brightness-0 h-auto"
            />
            <h1 className="text-[50px] font-bold leading-[100%] text-[Archivo]">NEEP</h1>
          </div>
          <p className="text-[18px] font-medium mt-0 leading-[100%] text-[Archivo]">
            Next Generation Education Platform
          </p>
        </div>

        <div className="flex-grow flex items-center z-10">
          <h2
            className="relative text-[5.5rem] font-normal italic text-white text-center lg:text-left"
            style={{ fontFamily: "'Protest Riot', cursive", lineHeight: "100%", paddingLeft: "5%" }}
          >
            Welcome
          </h2>
        </div>


        <svg className="absolute -bottom-3 -left-28 opacity-50 z-0" width="380" height="250" fill="none">
          <circle cx="71.5" cy="278.5" r="278" stroke="#0575E6" strokeWidth="0.7" />
        </svg>
        <svg className="absolute -bottom-20 -left-8 opacity-50 z-0" width="420" height="260" fill="none">
          <circle cx="152.5" cy="278.5" r="278" stroke="#0575E6" strokeWidth="0.7" />
        </svg>

        <p className="absolute bottom-1 left-1/2 transform -translate-x-1/2 text-sm text-center opacity-80 z-10">
          Powered by <span className="font-semibold">Transpoze.ai</span>
        </p>

      </div>


      <div className="flex items-center justify-center w-full lg:w-1/2 relative">
        <div className="relative z-10 lg:p-2 md:p-4 sm-p-4" style={{ width: '80%', maxWidth: '400px', border: 'none' }}>
          <div className="lg:hidden flex flex-col px-4 pb-4">
            <div className="flex items-start">
              <img
                src={TranspozeLogo}
                alt="Transpoze Logo"
                className="mr-1 h-10 w-10" 
              />
              <h1 className="text-4xl font-bold leading-[100%] text-[Archivo] text-blue-700 mt-2">NEEP</h1>
            </div>
          </div>


          <div className="p-1">
            {errorMessage && (
              <div className="mb-4 text-red-600 font-bold">
                {errorMessage}
              </div>
            )}
            <h2 className="mb-4 font-bold text-2xl text-[rgb(44,114,242)] px-4">Login</h2>
            <form onSubmit={submit}>
              <div className="mb-3 px-4">
                <input
                  type="text"
                  value={username}
                  onChange={handleUsernameChange}
                  placeholder="User Id"
                  className="w-full p-4 rounded-lg bg-[#F5F5F7] h-16 autofill-fix"
                  style={{ borderRadius: '10px' }}
                />
              </div>
              <div className="mb-3 px-4">
                <div className="relative flex items-center">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Password"
                    className="w-full p-4 pr-12 rounded-lg bg-[#F5F5F7] h-16 autofill-fix"
                    style={{ borderRadius: '10px' }}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 cursor-pointer text-gray-500"
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </span>
                </div>
              </div>
              <div className="mb-3">
                <br />
              </div>
              <button
                type="submit"
                className="w-full bg-[rgb(44,114,242)] border-none h-14 rounded-lg text-white font-bold text-base flex justify-center items-center disabled:opacity-75 disabled:cursor-not-allowed mx-4" // Added horizontal margin
                style={{ borderRadius: '8px', maxWidth: 'calc(100% - 32px)' }}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>Logging in...</span>
                  </>
                ) : (
                  'Login'
                )}
              </button>
            </form>
          </div>

          {/* Mobile-only Footer */}
          <p className="lg:hidden mt-10 text-sm text-center opacity-80 z-10 text-gray-500">
            Powered by <span className="font-semibold">Transpoze.ai</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;